import styled from 'styled-components';

export const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;
